import { useState } from "react";

import { AgentCard } from "src/agentNode/components/agentSelectionModal/AgentCard";
import { SearchBox } from "src/base-components/SearchBox";
import { Agent } from "src/clients/agent-management";
import { useFuseSearch } from "src/utils/useFuseSearch";

type Props = {
  agents: Agent[];
  onSelect: (agent: Agent) => void;
};

export const AgentList: React.FC<Props> = ({ agents, onSelect }) => {
  const [filter, setFilter] = useState("");
  const search = useFuseSearch(agents, { keys: ["name"] });

  return (
    <div className="flex h-full flex-col">
      <div className="mb-2">
        <div className="border-gray-100 border-b pb-2">
          <SearchBox
            dataLoc="search-select-agent"
            placeholder="Search an Agent"
            onChange={setFilter}
          />
        </div>
      </div>
      <ul className="decideScrollbar !overflow-y-scroll -mr-4 flex flex-col gap-y-3">
        {search(filter).map((agent) => (
          <AgentCard
            key={agent.id}
            agent={agent}
            onClick={() => onSelect(agent)}
          />
        ))}
      </ul>
    </div>
  );
};
